import React, { useEffect, useState } from 'react';
import configData from '../../../temp/config';
import { withTranslation } from 'react-i18next';

import "./ToggleSwitch.css";

const ToggleSwitch = (props) => {
  const [isToggled, setIsToggled] = useState(false);
  const onToggle = (e) => {
    if(e.target.checked){
      sessionStorage.setItem('unit', props.componentData.unitInchLabel.value)
      props.getUnitType(props.componentData.unitInchLabel.value)
    }else{
      sessionStorage.setItem('unit', props.componentData.unitCmLabel.value)
      props.getUnitType(props.componentData.unitCmLabel.value)
    }
    setIsToggled(!isToggled);
  }

  useEffect(() => {
    // props.getUnitType(props.componentData.unitCmLabel.value)
    sessionStorage.setItem('unit', props.componentData.unitCmLabel.value)
  }, [])

  return (
    <div className="switch-box-wrapper">
      <p className={isToggled ? "unit-text disabled-unit-text" : "unit-text"}>{props.componentData.unitCmLabel.value}</p>
      <label className="toggle-unit-switch">
        <input type="checkbox" checked={isToggled} onChange={onToggle} />
        <span className="switch" />
      </label>
      <p className={!isToggled ? "unit-text disabled-unit-text" : "unit-text"}>{props.componentData.unitInchLabel.value}</p>
    </div>
  );
}
export default ToggleSwitch;
